var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"subtitle is-4"},[(_vm.arrow)?_c('div',{staticClass:"is-flex"},[_c('Arrow',{attrs:{"type":"left"}}),_vm._t("default")],2):[_vm._t("default")]],2),(_vm.hr)?_c('div',{staticClass:"is-divider"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }